import gql from 'graphql-tag';

export const MARKET_DATA = gql`
    query ETFMarketData($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            inavTicker
            inceptionDate
            transparencyTypeName
            averageAnnualTotalReturns {
                quarterly {
                    asOfDate
                }
            }
            price {
                asOfDate
                navPrice
                navPricePercentChange
                closingPrice
                closingPricePercentChange
                outstandingShares
                premiumDiscountValuePercent
                totalAssets
                dailyTradingVolumeShares: dailyVolume
            }
        }
    }
`;

export const FI_MARKET_DATA = gql`
    query ETFMarketData($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            inavTicker
            inceptionDate
            averageAnnualTotalReturns {
                quarterly {
                    asOfDate
                }
            }
            price {
                asOfDate
                navPrice
                navPricePercentChange
                closingPrice
                closingPricePercentChange
                outstandingShares
                premiumDiscountValuePercent
                totalAssets
                dailyTradingVolumeShares: dailyVolume
            }
        }
    }
`;
